import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/adminUserActions'
import { initialEditForm } from '../../actions/profileCommon'

const profileFor = (state = null, action) => {
  switch (action.type) {
    case actions.EDIT_PROFILE_VIEW:
      return action.userId

    case actions.CLEAR_EDIT_PROFILE:
      return null

    default:
      return state
  }
}

export default combineReducers({
  profileFor,
  updateRequest: h2Api.restReducer(actions.EDIT_PROFILE_REQUEST),
  form: modelReducer('admin.users.edit.form', initialEditForm),
  forms: formReducer('admin.users.edit', { form: initialEditForm })
})
